import { InjectionToken } from "@angular/core";

export type OrganizationId = number;
export type OrganizationIdentifier = "Global" | "Cic" | "Uri" | "Agb" | undefined;

export const DPL_DATAENTRY_VIEW_PERMISSION = "dpl_dataentry_view";
export const DPL_DATAENTRY_EDIT_PERMISSION = "dpl_dataentry_edit";

export enum Permission {
    Read = "read",
    Update = "update",
    Manage = "manage"
}

export interface AuthorizationPermission {
    product: string;
    permissions: string[];
}

export interface AuthorizationOrganization {
    organizationId: OrganizationId;
    agbCode: string | null;
    cicCode: number | null;
    mrdmUri: string | null;
    name: string;
    position: string;
}

export interface AuthorizationExtendedPermission
    extends AuthorizationPermission,
        AuthorizationOrganization {
    applicationInstance: string;
}

export interface AuthorizationProfile {
    accountId: number;
    email: string;
    firstName: string;
    lastName: string;
    organizations: AuthorizationOrganization[];
    isDisabled: boolean;
    isInternal: boolean;
    metadata: Record<string, string>;
}

export const MRDM_AUTH_API_URL = new InjectionToken<string>("MrdmAuthApiUrl");
export const APPLICATION_INSTANCE = new InjectionToken<string>("ApplicationInstance");
export const PRODUCT = new InjectionToken<string>("DPProduct");
